import { useState, useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { path, storage } from '@commons';
import { CONFIG_SESSION } from '@handler';
import {
  Container,
  Row,
  Col,
  Modal,
  ModalHeader,
  ModalBody,
} from 'reactstrap';
import './styles.css';

const GlobalNoticeBar = ({ children, countdownEndDate, image, text }) => {
  const location = useLocation();

  const [timeLeft, setTimeLeft] = useState({
    days: 0,
    hours: 0,
    minutes: 0,
    seconds: 0,
  });
  const [isVideoModalOpen, setIsVideoModalOpen] = useState(false);
  const [isVisible, setIsVisible] = useState(true);

  const toggleVideoModal = () => setIsVideoModalOpen(!isVideoModalOpen);

  const handleScheduleContact = () => {
    const whatsappUrl = 'https://wa.me/5554999370972?text=Olá!%20Estou%20testando%20a%20plataforma%20Agrare%20Gestor%20Rural%20e%20gostaria%20de%20conversar%20com%20um%20especialista%20para%20tirar%20minhas%20dúvidas%20e%20ver%20se%20faz%20sentido%20para%20minha%20fazenda.';
    window.open(whatsappUrl, '_blank');
  };

  const configSessionRaw = storage.get(CONFIG_SESSION);
  const configSession = configSessionRaw ? JSON.parse(configSessionRaw) : null;

  const contaAgrare = configSession?.contaAgrare;
  const schemaSelecionado = configSession?.schemaSelecionado;
  const isTrialLicense = contaAgrare?.trialLicense;

  const userRaw = storage.get(path.sessionUser);
  const user = userRaw ? JSON.parse(userRaw) : null;
  const isNotStudent = user?.perfil !== 'ESTUDANTE_PESQUISA';
  const showBar = false;

  const isHomeOrPostOnboarding = location.pathname === '/home' || location.pathname === '/pos-onboarding';
  const shouldShowNotice = 
      !isHomeOrPostOnboarding &&
      isVisible &&
      schemaSelecionado &&
      isNotStudent &&
      (isTrialLicense || showBar);

  // TODO: Substituir lógica fixa por verificação real da licença  e TypeNotification
  const typeNotication = 'informativo';

  const countdownDate = new Date();
  countdownDate.setDate(countdownDate.getDate() + 7);

  const getBarClasses = () => {
    return `global-notice-bar global-notice-bar--${isTrialLicense ? 'agendamento' : typeNotication}`;
  };

  const getContentLayoutClasses = () => {
    let classes = 'global-notice-bar__content-layout';
    if (typeNotication === 'manutencao') {
      classes += ' global-notice-bar__content-layout--manutencao';
    }
    return classes;
  };

  const handlePrimaryAction = (action) => {
    if (typeof action === 'string') {
      alert(`Ação executada: ${action}`);
    } else {
      alert('Ação principal executada!');
    }
  };

  const renderContent = (type) => {
    switch (type) {
      case 'informativo':
        return (
          <div className={getContentLayoutClasses()}>
            {image && <img src={image} alt={text} />}

            {!image && <span className="global-notice-bar__text">{text}</span>}

            {/* <button
              onClick={handlePrimaryAction}
              className="global-notice-bar__button informativo global-notice-bar__button--primary"
            >
              Bora lá!
            </button> */}
          </div>
        );

      case 'manutencao':
        return (
          <div className={getContentLayoutClasses()}>
            <span className="global-notice-bar__text">{text}</span>
            <div className="global-notice-bar__countdown">
              <div className="global-notice-bar__countdown-container">
                <div className="global-notice-bar__countdown-item">
                  <div className="global-notice-bar__countdown-number">
                    {timeLeft.days.toString().padStart(2, '0')}
                  </div>
                  <div className="global-notice-bar__countdown-label">dias</div>
                </div>
                <div className="global-notice-bar__countdown-item">
                  <div className="global-notice-bar__countdown-number">
                    {timeLeft.hours.toString().padStart(2, '0')}
                  </div>
                  <div className="global-notice-bar__countdown-label">
                    horas
                  </div>
                </div>
                <div className="global-notice-bar__countdown-item">
                  <div className="global-notice-bar__countdown-number">
                    {timeLeft.minutes.toString().padStart(2, '0')}
                  </div>
                  <div className="global-notice-bar__countdown-label">min</div>
                </div>
                <div className="global-notice-bar__countdown-item">
                  <div className="global-notice-bar__countdown-number">
                    {timeLeft.seconds.toString().padStart(2, '0')}
                  </div>
                  <div className="global-notice-bar__countdown-label">seg</div>
                </div>
              </div>
            </div>
          </div>
        );

      case 'agendamento':
        return (
          <>
            <div className={getContentLayoutClasses()}>
              <div className="global-notice-bar__button-group">
                <button
                  onClick={toggleVideoModal}
                  className="global-notice-bar__button global-notice-bar__button--dark"
                >
                  <i className="pi pi-play global-notice-bar__icon"></i>
                  Ver Demonstração
                </button>
                <button
                  onClick={handleScheduleContact}
                  className="global-notice-bar__button global-notice-bar__button--outline"
                >
                  <i className="pi pi-calendar global-notice-bar__icon"></i>
                  Agendar Conversa
                </button>
              </div>
            </div>

            {/* Modal do Vídeo */}
            <Modal
              isOpen={isVideoModalOpen}
              toggle={toggleVideoModal}
              size="lg"
              centered
              className="video-demo-modal"
            >
              <ModalHeader toggle={toggleVideoModal}>
                Demonstração Agrare Gestor Rural
              </ModalHeader>
              <ModalBody className="p-0">
                <div style={{padding:'56.25% 0 0 0', position:'relative'}}>
                  <iframe
                    src="https://player.vimeo.com/video/1110718508?title=0&byline=0&portrait=0&badge=0&autopause=0&player_id=0&app_id=58479"
                    frameBorder="0"
                    allow="autoplay; fullscreen; picture-in-picture; clipboard-write; encrypted-media; web-share"
                    referrerPolicy="strict-origin-when-cross-origin"
                    style={{position:'absolute', top:0, left:0, width:'100%', height:'100%'}}
                    title="Demonstração Agrare Gestor Rural"
                  />
                </div>
              </ModalBody>
            </Modal>
          </>
        );

      default:
        return null;
    }
  };

  useEffect(() => {
    if (typeNotication !== 'manutencao' || !countdownEndDate) return;

    const timer = setInterval(() => {
      const now = new Date().getTime();
      const endTime = new Date(countdownEndDate).getTime();
      const difference = endTime - now;

      if (difference > 0) {
        setTimeLeft({
          days: Math.floor(difference / (1000 * 60 * 60 * 24)),
          hours: Math.floor(
            (difference % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60),
          ),
          minutes: Math.floor((difference % (1000 * 60 * 60)) / (1000 * 60)),
          seconds: Math.floor((difference % (1000 * 60)) / 1000),
        });
      } else {
        setTimeLeft({ days: 0, hours: 0, minutes: 0, seconds: 0 });
      }
    }, 1000);

    return () => clearInterval(timer);
  }, [typeNotication, countdownEndDate]);

  return (
    <>
      {shouldShowNotice && (
        <div className={getBarClasses()}>
          <Container fluid>
            <Row className="align-items-center global-notice-bar__container">
              <Col>
                <div className="global-notice-bar__wrapper">
                  <div>
                    {isTrialLicense
                      ? renderContent('agendamento')
                      : renderContent(typeNotication)}
                  </div>
                  
                  {!isTrialLicense && (
                    <button
                    onClick={() => setIsVisible(false)}
                    className="global-notice-bar__button--close"
                    aria-label="Fechar notificação"
                  >
                    <i className="pi pi-times global-notice-bar__close-icon"></i>
                  </button>
                  )}
                </div>
              </Col>
            </Row>
          </Container>
        </div>
      )}

      <div
        className={`topbar-wrapper ${shouldShowNotice ? 'with-notice' : 'no-notice'}`}
      >
        {children}
      </div>
    </>
  );
};

export default GlobalNoticeBar;
